import axios from 'axios';
import * as endpoint from '../../../endpoint';
import * as actionTypes from '../../../actionTypes';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

/**
 * グループに紐づくタグ情報を取得する
 *
 * @param {string} apiToken - apiトークン
 * @param {Object} apiParams - APIリクエストのパラメータ。`depth`（タグの階層）、
 *                            `parentId`（親タグのID）、`isEdit`（編集可能状態）、
 *                            `isUsable`（使用可能状態）、`groupId`（グループID）、
 *                            `isDeleted`（削除済み状態）を含むオブジェクト。
 * @returns {Function} Redux dispatch関数
 */
const getTags = (apiToken, apiParams) => dispatch => {
  consolelog('[API CALL] getTags()');
  configureAxiosForJSON(apiToken);
  const { cancelToken, cancelTokenKey } = createCancelToken('getTags');
  const {
    depth,
    parentId = null,
    isEdit = false,
    isUsable = false,
    groupId = null,
    isDeleted = false,
  } = apiParams;
  const axiosParams = {
    params: {
      depth,
      parentId,
      isUsable: isUsable || null,
      groupId: groupId || null,
      isDeleted,
    },
    cancelToken,
  };

  if (groupId === '') {
    return;
  }
  const url = endpoint.API_GET_TAGS.replace('{groupId}', groupId);

  // eslint-disable-next-line consistent-return
  return axios
    .get(url, axiosParams)
    .then(res => {
      delCancelToken(cancelTokenKey);
      dispatch({
        type: actionTypes.SUCCESS_API_GET_TAGS,
        payload: res.data,
        searchOptions: {
          depth,
          parentId,
        },
        isEdit,
      });
    })
    .catch(thrown => {
      delCancelToken(cancelTokenKey);
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(thrown, dispatch);
      }
    });
};

export default getTags;
